import ChatDetail from "./ChatDetail";
import SavedMessage from "./SavedMessage";
import Contacts from "./Contacts";
import ContactInfo from "./ContactInfo";
import AddGroup from "./AddGroup";
import i18n from "@/i18n";
import Vue from 'vue'
Vue.use(i18n);
export default [

  {
    path: '/chat-detail',
    name: i18n.t('conversation'),
    meta: {
      requiresAuth: true,
      name: i18n.t('conversation')
    },

    component: ChatDetail
  },
  {
    path: '/saved-message',
    name: i18n.t('savedMessage'),
    meta: {
      requiresAuth: true,
      name: i18n.t('savedMessage')
    },
    component: SavedMessage
  },
  {
    path: '/contacts',
    name: i18n.t('contacts'),
    meta: {
      requiresAuth: true,
      name: i18n.t('contacts')
    },
    component: Contacts
  },
  {
    path: '/contact-info',
    name: i18n.t('contactInfo'),
    meta: {
      requiresAuth: true,
      name: i18n.t('contactInfo')
    },
    component: ContactInfo
  },
  {
    path: '/add-group',
    name: i18n.t('addGroup'),
    meta: {
      requiresAuth: true,
      name: i18n.t('addGroup')
    },
    component: AddGroup
  }
]
